import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'percentage-100', 'IconPercentage100', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","fill":"currentColor","key":"svg-0"}]]);